// src/redux/slices/isTrackingActionSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig"; // adjust path if needed
import config from "../../config/api";

const API_URL = `${config.backendUrl}/project-assigned/project-assigned-email`;

export const sendTrackingActionEmail = createAsyncThunk(
  "trackingAction/sendEmail",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(API_URL, payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "Something went wrong" }
      );
    }
  }
);

const isTrackingActionSlice = createSlice({
  name: "trackingAction",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  reducers: {
    resetTrackingState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendTrackingActionEmail.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(sendTrackingActionEmail.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(sendTrackingActionEmail.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload?.message || "Failed to send email";
      });
  },
});

export const { resetTrackingState } = isTrackingActionSlice.actions;
export default isTrackingActionSlice.reducer;
